import './components/groups/groups-panel';
import './components/identity';
import './components/report-schedules';

import * as angular from 'angular';

import { OrgSettingsComponent } from '~/modules/org-settings/org-settings.component';
import { SharedUiModule } from '~/modules/shared-ui/shared-ui.module';

import { CommonModule } from './common/common.module';
import { OrgSettingsRoutesConfig } from './org-settings.routes';
import NavigationHistoryService from './services/navigation-history-service';
import { RouterLoggingService } from './services/router-logging-service';
import { FeatureToggleService } from '~/services/feature-toggle-service';
import { ConnectionsModule } from '~/modules/org-settings/components/connections/connections.module';
import { ColorPalettesModule } from './components/color-palettes/color-palettes.module';
import { WorkspaceSettingsFeatureMembersAngularJsModule } from '@mode/workspace-settings/feature-members-angularjs';
import { OrgSettingsService } from '@mode/workspace-settings/shell-angularjs';
import { DowngradedWorkspaceSettingsFeatureGoogleModule } from '../downgraded-angular/workspace-settings/feature-google.module';
import { DowngradedWorkspaceSettingsUIModule } from '../downgraded-angular/workspace-settings/ui.module';

export const OrgSettingsModule = angular
  .module('org-settings', [
    CommonModule,
    ConnectionsModule,
    ColorPalettesModule,
    'groups-panel',
    'identity',
    WorkspaceSettingsFeatureMembersAngularJsModule,
    'report-schedules',
    SharedUiModule,
    DowngradedWorkspaceSettingsFeatureGoogleModule,
    DowngradedWorkspaceSettingsUIModule,
  ])
  .config(OrgSettingsRoutesConfig)
  .config([
    '$locationProvider',
    ($locationProvider) => {
      const baseTagIsSet = !!document.getElementsByTagName('base').length;

      if (baseTagIsSet) {
        $locationProvider.hashPrefix('');
        $locationProvider.html5Mode({
          enabled: true,
          rewriteLinks: false,
        });
      }
    },
  ])
  .component('orgSettings', OrgSettingsComponent)
  .service('FeatureToggleService', FeatureToggleService)
  .service('OrgSettingsService', OrgSettingsService)
  .service('NavigationHistoryService', NavigationHistoryService)
  .service('RouterLoggingService', RouterLoggingService)
  .run([
    'NavigationHistoryService',
    'RouterLoggingService',
    (nhs, rls) => {
      nhs.init();
      rls.init();
    },
  ])
  .run([
    '$state',
    '$transitions',
    ($state, $transitions) => {
      $transitions.onError({}, function (trans) {
        // notify the user
        // TODO (Franklin) 06/17/2020: Work with product & support to communicate through the UI and not dev-tools console
        console.error('$stateChangeError', trans.error());
      });
    },
  ]).name;
